import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@material-ui/core/styles';

import TermsDialog from '../content/TermsDialog';
import PricingDialog from '../content/PricingDialog';
import { useModal } from '../../utils/modal';

import { createGuestToken, logOut } from '../../store/actions/auth';
import config from '../../config';

function Footer() {
  const dispatch = useDispatch();
  const { t } = useTranslation(['footer', 'common']);
  const termsModal = useModal();
  const pricingModal = useModal();
  const theme = useTheme();
  const tenant = useSelector(state => state.tenant);
  const isAuthenticated = useSelector(state => state.auth.isAuthenticated);
  const useBilling = tenant.useBilling;

  const handleLegalClick = () => {
    termsModal.open();
  };

  const handleLogout = async () => {
    await dispatch(logOut());
    await dispatch(createGuestToken());
  };

  return (
    <div className="tenant-footer">
      <div className="menu-items">
        {isAuthenticated ? (
          <div className="menu-item" onClick={handleLogout}>
            <span>{t('logout')}</span>
          </div>
        ) : null}

        <div className="menu-item" onClick={handleLegalClick}>
          <span>{t('terms')}</span>
        </div>
        <TermsDialog open={termsModal.isOpen} onClose={termsModal.close} />
        <PricingDialog
          open={pricingModal.isOpen}
          onClose={pricingModal.close}
        />
        <div className="menu-item">
          <a
            target="_blank"
            href={theme.tenant.politique_de_confidentialite_url}
          >
            {t('privacy')}
          </a>
        </div>

        {useBilling ? (
          <div className="menu-item" onClick={pricingModal.open}>
            <span>{t('common:tarification')}</span>
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default Footer;
